// extracted by mini-css-extract-plugin
export default {"preview_section":"KRR_SinglePreviewFromEditState_preview_section__T0Xgu"};